import { getSignInMountPath, OktaUserInfo } from '@/app/core/auth';
import { AccessDenied } from '@/app/core/components/AccessDenied';
import { Redirect } from 'react-router-dom';
import { Entitlement } from '@ascend/authz';
import {
  getShortNameForProductToLower,
  isSuperAdmin,
  ProductNameEnum,
} from '@ssar-app/domain';

export const DefaultProductRouter = () => {
  const userProfile = OktaUserInfo.getOktaUserInfo();

  const redirectToProduct = () => {
    if (userProfile) {
      if (isSuperAdmin(userProfile)) {
        return (
          <Redirect
            to={`/${getShortNameForProductToLower(
              ProductNameEnum.AscendQuest,
            )}`}
          />
        );
      } else {
        const entitlements = (userProfile.entitlements as Entitlement[]) || [];
        if (entitlements.length) {
          return (
            <Redirect
              to={`/${getShortNameForProductToLower(entitlements[0].context)}`}
            />
          );
        } else {
          return <AccessDenied />;
        }
      }
    } else {
      return <Redirect to={getSignInMountPath()} />;
    }
  };

  return <>{redirectToProduct()}</>;
};
